import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { PaymentPlanDetailView } from '@mews-commander/modules/src/modules/payment';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => {
    const { paymentPlanId, accountId } = Route.useParams();
    return <PaymentPlanDetailView accountId={accountId} paymentPlanId={paymentPlanId} />;
};

export const Route = createFileRoute(
    '/_authenticated/$currentEnterpriseId/Payment/Plans/$accountId/Detail/$paymentPlanId'
)({
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.paymentPlanEnabled);
    },
    loader: async ({ params: { paymentPlanId }, context: { ensureQueryData } }) => {
        const { name } = await ensureQueryData('paymentPlans', 'getById', { id: paymentPlanId });

        return {
            title: () => name || TextKey.PaymentPlan,
        };
    },
    component: Component,
    staticData: {
        owner: MewsTeam.PaymentExperience,
        type: RouteType.Frontend,
    },
});
